import { render, staticRenderFns } from "./batchProduct.vue?vue&type=template&id=703be44e&scoped=true&"
import script from "./batchProduct.vue?vue&type=script&lang=js&"
export * from "./batchProduct.vue?vue&type=script&lang=js&"
import style0 from "./batchProduct.vue?vue&type=style&index=0&id=703be44e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703be44e",
  null
  
)

export default component.exports